import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { SiFormItemComponent } from '@siemens/element-ng/form';
import { ApplicationDetailDashboardBoxComponent } from '../application-detail-dashboard-box/application-detail-dashboard-box.component';
import { SimpleBaseEffectiveControlComponent } from '../simple-base-effective-control.component';

@Component({
    selector: 'tran-application-detail-textarea',
    imports: [ApplicationDetailDashboardBoxComponent, ReactiveFormsModule, SiFormItemComponent, TranslatePipe],
    templateUrl: './application-detail-textarea.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationDetailTextareaComponent extends SimpleBaseEffectiveControlComponent<string | null> {
    public readonly heading = input<string>('');
    public readonly placeholder = input<string>(
        'components.application-detail-dashboard.application-detail-textarea.placeholder'
    );
}
